import { createRequestTypes } from '../../../utils';

export const LOAD_HOMEPAGE_FORM = 'ui/homepage/homePageForm/LOAD_HOMEPAGE_FORM';
export const SAVE_BUTTON_CLIKED = 'ui/homepage/homePageForm/SAVE_BUTTON_CLICKED';
export const FETCH_HOMEPAGE_FORM = createRequestTypes('ui/homepage/homePageForm/FETCH_HOMEPAGE_FORM');
export const SAVE_HOMEPAGE_FORM = createRequestTypes('ui/homepage/homePageForm/SAVE_HOMEPAGE_FORM');
